import React from "react";
import AuthUserCard from "../AuthUserCard/AuthUserCard";

interface PageHeaderProps {
  leftContent?: React.ReactNode;
  showUserCard?: boolean;
  rightContent?: React.ReactNode;
}

export function PageHeader({
  leftContent,
  showUserCard = true,
  rightContent,
}: PageHeaderProps) {
  return (
    <div className="px-6 py-3 flex justify-between items-center w-full">
      {leftContent}
      {rightContent ||
        (showUserCard && (
          <div className="w-52">
            <AuthUserCard />
          </div>
        ))}
    </div>
  );
}
